import React from 'react';
import './ModifierValue.less';

export const ModifierValue = ({children, isSmall}) => {
	return <div className={`modifier-value ${isSmall ? 'modifier-value--small' : ''}`}>
		{children}
	</div>;
};
